import { useState, useEffect } from "react";
import { LayoutDashboard, LineChart, ArrowRightLeft, Table } from "lucide-react";

const ITEMS = [
  { id: "overview", label: "Overview", icon: LayoutDashboard },
  { id: "trends", label: "Trends", icon: LineChart },
  { id: "compare", label: "Compare", icon: ArrowRightLeft },
  { id: "ledger", label: "Ledger", icon: Table },
];

export const MobileNav = ({ showCompare = true }) => {
  const [active, setActive] = useState("overview");
  const items = ITEMS.filter((i) => showCompare || i.id !== "compare");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px" }
    );
    ITEMS.forEach((i) => {
      const el = document.getElementById(i.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-t border-slate-200 pb-[env(safe-area-inset-bottom)]"
    >
      <div className={items.length === 4 ? "grid grid-cols-4" : "grid grid-cols-3"}>
        {items.map((i) => (
          <a
            key={i.id}
            href={`#${i.id}`}
            data-testid={`mobile-nav-${i.id}`}
            className={`flex flex-col items-center gap-1 py-2.5 transition-colors ${
              active === i.id ? "text-[#B08D26]" : "text-slate-400"
            }`}
          >
            <i.icon size={18} strokeWidth={active === i.id ? 2.4 : 2} />
            <span className={`text-[10px] tracking-wide ${active === i.id ? "font-bold" : "font-semibold"}`}>{i.label}</span>
          </a>
        ))}
      </div>
    </nav>
  );
};
